import React from 'react';
import { HeaderWrap, HeaderFixed } from './styled';

const HeaderTemplate = (props: React.PropsWithChildren<{}>) => (
	<HeaderWrap>
		<HeaderFixed>{props.children}</HeaderFixed>
	</HeaderWrap>
);

export default HeaderTemplate;
